window.Pace = require('pace-js');
window.Cookies = require('js-cookie');
window.jsPDF = require('jspdf');
window.toastr = require('toastr');
window.moment = require('moment');
window.PasswordValidation = require('../../../assets/global/plugins/passvalidation/passvalidation');
window.bootbox = require('../../../assets/global/plugins/bootbox/bootbox.min');

require('../../../assets/global/plugins/jquery.blockui.min');
require('../../../assets/global/plugins/icheck/icheck');
require('../../../assets/global/plugins/bootstrap-switch/js/bootstrap-switch');
require('../../../assets/global/plugins/footable/footable');
require('../../../assets/global/plugins/jquery-slimscroll/jquery.slimscroll');
require('../../../assets/global/plugins/bootstrap-multiselect/js/bootstrap-multiselect');
require('../../../assets/global/plugins/daterangepicker/js/daterangepicker');
require('../../../assets/global/plugins/bootstrap-datepicker/js/bootstrap-datepicker');
require('../../../assets/global/plugins/bootstrap-timepicker/js/bootstrap-timepicker.min');
require('../../../assets/global/plugins/bootstrap-colorpicker/js/bootstrap-colorpicker');
require('../../../assets/global/plugins/jquery-minicolors/jquery.minicolors.min');
require('../../../assets/global/plugins/jquery-multi-select/js/jquery.multi-select');
require('interactjs');
require('summernote');
//require('../../../assets/global/plugins/select2/js/select2.min');
//require('../../../assets/global/plugins/select2/js/i18n/fr');
//require('../../../assets/global/plugins/select2/js/select2_addon');
require('jquery-contextmenu');
require('select2');
//require('../../../assets/layouts/global/scripts/quick-sidebar.min');
//require('../../../assets/global/plugins/bootstrap-hover-dropdown/bootstrap-hover-dropdown.min');

require('../../../assets/global/plugins/jquery-validation/js/jquery.validate')
if (window.currentLang == "fr") {
  require('../../../assets/global/plugins/jquery-validation/js/localization/messages_fr');
}